export enum VendorServiceStatusType {
  NoStatus = 0,
  Needed = 1,
  InProgress = 2,
  Completed = 3
}
